// extracted by mini-css-extract-plugin
module.exports = {"ldsSpinner":"Loader_ldsSpinner__KuEUU","blue":"Loader_blue__7gLEq","white":"Loader_white__AUCdd"};